import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";

import Layout from "@/components/Layout";
import AnalyticsRouteTracker from "@/components/AnalyticsRouteTracker";
import Home from "@/pages/Home";
import Ristrutturazioni from "@/pages/Ristrutturazioni";
import Edificazioni from "@/pages/Edificazioni";
import Operazioni from "@/pages/Operazioni";
import Team from "@/pages/Team";
import Portfolio from "@/pages/Portfolio";
import Contatti from "@/pages/Contatti";
import Privacy from "@/pages/Privacy";
import Simulatore from "@/pages/Simulatore";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <HelmetProvider>
      <div className="App font-body">
        <BrowserRouter>
          <AnalyticsRouteTracker />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/ristrutturazioni" element={<Ristrutturazioni />} />
              <Route path="/edificazioni" element={<Edificazioni />} />
              <Route path="/operazioni-immobiliari" element={<Operazioni />} />
              <Route path="/team" element={<Team />} />
              <Route path="/portfolio" element={<Portfolio />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="/simulatore" element={<Simulatore />} />
              <Route path="/privacy" element={<Privacy />} />
            </Route>
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="light" richColors position="top-right" />
      </div>
    </HelmetProvider>
  );
}

export default App;
